module.exports = __webpack_public_path__ + "static/media/backgroundMaskBtnDashboard.f4953560.svg";